import Button from '@/components/base/Button';
import Reveal from '@/components/base/Reveal';
import { HOW_IT_WORKS_STEPS } from '@/data/site';

export default function ProcessSection() {
  return (
    <section className="w-full px-4 md:px-8 lg:px-12 py-16 md:py-28 bg-background-100 border-y border-background-200">
      <div className="max-w-content mx-auto">
        <Reveal className="max-w-3xl">
          <span className="font-label text-xs uppercase tracking-widest2 text-primary-400">
            How It Works
          </span>
          <h2 className="mt-4 font-heading text-2xl md:text-4xl leading-tight text-foreground-950">
            Tell us what you need. We&rsquo;ll find the right people.
          </h2>
          <p className="mt-5 text-base leading-relaxed text-foreground-700 max-w-2xl">
            No endless searching. No overwhelming directories. Just thoughtful, personal connections.
          </p>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
          {HOW_IT_WORKS_STEPS.map((step, index) => (
            <Reveal
              key={step.number}
              delay={index * 90}
              className="rounded-lg border border-background-200 bg-background-50 p-6 md:p-7"
            >
              <span className="font-heading text-3xl md:text-4xl text-accent-500">{step.number}</span>
              <h3 className="mt-5 font-heading text-lg md:text-xl text-foreground-950">{step.title}</h3>
              <p className="mt-3 text-base leading-relaxed text-foreground-700">{step.body}</p>
            </Reveal>
          ))}
        </div>

        <div className="mt-10">
          <Button to="/contact" variant="primary" size="lg">
            Tell Us What You&rsquo;re Looking For
          </Button>
        </div>
      </div>
    </section>
  );
}